import React from 'react';

interface Props {
  onEdit: () => void;
  onDelete: () => void;
  disabled?: boolean;
}

export const ManualAssetActions: React.FC<Props> = ({ onEdit, onDelete, disabled }) => (
  <div style={{ display: 'flex', gap: 8 }}>
    <button onClick={onEdit} disabled={disabled} style={{ padding: '4px 10px', borderRadius: 5, border: 'none', background: '#eee', color: '#1976d2', fontWeight: 500, cursor: disabled ? 'not-allowed' : 'pointer' }}>Edit</button>
    <button
      onClick={() => {
        if (disabled) return;
        if (window.confirm('Delete this manual asset?')) onDelete();
      }}
      disabled={disabled}
      style={{ padding: '4px 10px', borderRadius: 5, border: 'none', background: '#ffeaea', color: '#d32f2f', fontWeight: 500, cursor: disabled ? 'not-allowed' : 'pointer' }}
    >
      Delete
    </button>
  </div>
);
